// SPDX-License-Identifier: MIT
// Minimal Azure provider slice: marks that at least one Azure dataset has been ingested this session.

export interface AzureProviderState {
  providerDataLoaded: boolean;
}

const INITIAL_STATE: AzureProviderState = { providerDataLoaded: false };

export const AZURE_PROVIDER_DATA_LOADED = '@azure/PROVIDER_DATA_LOADED';

interface Action {
  type: string;
}

export function azureReducer(
  state: AzureProviderState = INITIAL_STATE,
  action: Action
): AzureProviderState {
  switch (action.type) {
    case AZURE_PROVIDER_DATA_LOADED:
      if (state.providerDataLoaded) return state; // idempotent
      return { ...state, providerDataLoaded: true };
    default:
      return state;
  }
}

export const setAzureProviderDataLoaded = () => ({ type: AZURE_PROVIDER_DATA_LOADED });

export const selectAzureProviderDataLoaded = (state: any): boolean =>
  Boolean(state.azure?.providerDataLoaded);
